export var getIsToggleCheckedControlled = function getIsToggleCheckedControlled(isToggleChecked) {
  return isToggleChecked !== null;
};